module.exports = __webpack_public_path__ + "media/icons/offer-details-automat@2x-ae5a3172.png";